/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag
     */
    type?: number;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTagToJSON(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerScreenerTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
    };
}

